const initialState = {
    dataFiles: false,
    dataFile: false,
    dataFileDatasets: false,
    totResultFiles: 0,
    totResultFileDatasets: 0,
}

const fileReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATA_FILES':
            return { ...state, dataFiles: action.payload }
        case 'DATA_FILE':
            return { ...state, dataFile: action.payload }
        case 'DATA_FILE_DATASETS':
            return { ...state, dataFileDatasets: action.payload }
        case 'TOT_RESULT_FILES':
            return { ...state, totResultFiles: action.payload }
        case 'TOT_RESULT_FILE_DATASETS':
            return { ...state, totResultFileDatasets: action.payload }
        default:
            return state
    }
}

export default fileReducer;